import i18n from '../../i18n';

export const getTranslationForLanguage = async (
  translationFile: string,
  key: string,
  lang: string,
) => {
  const fixedT = i18n.getFixedT(lang, translationFile);
  return fixedT(`${translationFile}:${key}`);
};
